import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { ApiService } from '../../services/api/api.service';

export const AppGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const router = inject(Router);
  const apiService = inject(ApiService);

  // Reaproveitada por 5 min (ApiService): este guard roda em toda navegacao do
  // sub-app, e duas vezes ao entrar.
  return from(apiService.getUsersActiveSubscriptionsCached()).pipe(
    map(response => {
      const subscriptions = response.message;
      const appId = route.data['appId'];

      if (!Array.isArray(subscriptions)) {
        router.navigate(['/inicio']);
        return false;
      }

      // O schema declara message como (UserActiveSubscriptionsInfo | null)[]:
      // sem o `sub !== null` um item nulo estoura aqui, cai no catchError e
      // manda o usuario para /inicio como se ele nao tivesse a assinatura.
      const hasAccess = subscriptions.some(
        sub => sub !== null && Number(sub.product_id) === Number(appId)
      );

      if (!hasAccess) {
        router.navigate(['/servicos']);
      }

      return hasAccess;
    }),
    catchError(error => {
      console.error('AppGuard - Error checking subscriptions:', error);
      router.navigate(['/inicio']);
      return of(false);
    })
  );
};
